import React, { useState, useEffect } from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { CurrentRelease } from '../../service/CurrentRelease';


const LogPage = () => {

   const [currentRelease, setCurrentRelease] = useState([]);

   useEffect(() => {

    CurrentRelease.getReleaseData().then((data) => {
        const sortedData = data.sort((a, b) => a.database.localeCompare(b.database));
        setCurrentRelease(sortedData);
    });
}, []);


   return (
    <>
    <Helmet>
        <title>Atlantis | Release Log</title>
      </Helmet>
      <Header/>
      <section className="px-5 py-10">
      <div className="container">
        <div className="row">
            <div className="col-sm-12 text-sm-start text-center">
                  <h1 className="display-5 fw-bold mb-4">Release Log</h1>
                   <p className="fs-1 text-justify">
                     The Atlantis database updates its data annually. Each data release includes updates from both variant and feature databases. Below are the details of the datasets and their corresponding versions included in each release. If there is a significant update to a data source, the portal conducts additional unscheduled updates to make the latest data available.
                   </p>

                    <h2 className="display-6 fw-bold mb-4">Current Releases</h2>
                    <p className="fs-1 text-justify">
                      Versions are shown as <em>source version / Atlantis ingestion date</em>.
                    </p>
                    <div className="col-sm-6 text-sm-start text-center mb-5">
                    <DataTable scrollable scrollHeight="500px"  value={currentRelease} showGridlines  size="small" tableStyle={{ minWidth: '50rem' }}>
                        <Column field="database" header="Database Name"></Column>
                        <Column field="version" header="Version / Update Date"></Column>
                    </DataTable>
                   </div>
                   <p className="fs-1 text-justify">
                  These are the versions used to compute the stored annotations and contacts.
                  Structures shown in the 3D viewer are fetched live from{' '}
                  <Link to="https://www.rcsb.org/" target="_blank" rel="noopener noreferrer">RCSB PDB</Link>,{' '}
                  <Link to="https://alphafold.ebi.ac.uk/" target="_blank" rel="noopener noreferrer">AlphaFold</Link> and{' '}
                  <Link to="https://alphafill.eu/" target="_blank" rel="noopener noreferrer">AlphaFill</Link>,
                  so an entry revised since the dates above will be displayed from newer
                  coordinates than the stored contacts describe.
                </p>
                <p className="fs-1 text-justify">
                  The multimer set combines AlphaFold DB dimer predictions with 54 adenylate
                  cyclase&ndash;G&alpha; complexes predicted in-house with AlphaFold2-Multimer v2.3
                  (ColabFold v1.5.2), five models at five recycles, the highest-confidence model
                  relaxed with Rosetta v2021.16. Monomer models come from AlphaFold DB v6.
                </p>
              </div>
        </div>
    </div>
</section>

    <Footer/>
   	</>
   )
}

export default LogPage